import { featureReadiness as vi_featureReadiness } from "./vi/featureReadiness.js";
import { featureReadiness as en_featureReadiness } from "./en/featureReadiness.js";
import { integrationControl as vi_integrationControl } from "./vi/integrationControl.js";
import { integrationControl as en_integrationControl } from "./en/integrationControl.js";
import { partnerConnections as vi_partnerConnections } from "./vi/partnerConnections.js";
import { partnerConnections as en_partnerConnections } from "./en/partnerConnections.js";
import { partnerReleases as vi_partnerReleases } from "./vi/partnerReleases.js";
import { partnerReleases as en_partnerReleases } from "./en/partnerReleases.js";
import { useCallback } from "react";

import { currentLocale, interpolate, useLocale, type Locale } from "./core.js";
import { common as en_common } from "./en/common.js";
import { shell as en_shell } from "./en/shell.js";
import { auth as en_auth } from "./en/auth.js";
import { attention as en_attention } from "./en/attention.js";
import { overview as en_overview } from "./en/overview.js";
import { integrations as en_integrations } from "./en/integrations.js";
import { audience as en_audience } from "./en/audience.js";
import { subscriptions as en_subscriptions } from "./en/subscriptions.js";
import { revenue as en_revenue } from "./en/revenue.js";
import { planMapping as en_planMapping } from "./en/planMapping.js";
import { feedback as en_feedback } from "./en/feedback.js";
import { support as en_support } from "./en/support.js";
import { appHome as en_appHome } from "./en/appHome.js";
import { bankTransfer as en_bankTransfer } from "./en/bankTransfer.js";
import { sharedHub as en_sharedHub } from "./en/sharedHub.js";
import { shopIntegrationCards as en_shopIntegrationCards } from "./en/shopIntegrationCards.js";
import { customers as en_customers } from "./en/customers.js";
import { acquisitionOps as en_acquisitionOps } from "./en/acquisitionOps.js";
import { invoiceQuota as en_invoiceQuota } from "./en/invoiceQuota.js";
import { resale as en_resale } from "./en/resale.js";
import { sources as en_sources } from "./en/sources.js";
import { reliability as en_reliability } from "./en/reliability.js";
import { cost as en_cost } from "./en/cost.js";
import { mailStatus as en_mailStatus } from "./en/mailStatus.js";
import { integrationRoutes as en_integrationRoutes } from "./en/integrationRoutes.js";
import { mailProviders as en_mailProviders } from "./en/mailProviders.js";
import { dependencies as en_dependencies } from "./en/dependencies.js";
import { products as en_products } from "./en/products.js";
import { platform as en_platform } from "./en/platform.js";
import { staff as en_staff } from "./en/staff.js";
import { teams as en_teams } from "./en/teams.js";
import { ownership as en_ownership } from "./en/ownership.js";
import { components as en_components } from "./en/components.js";
import { partnerSets as en_partnerSets } from "./en/partnerSets.js";
import { bankPartners as en_bankPartners } from "./en/bankPartners.js";
import { partnerLab as en_partnerLab } from "./en/partnerLab.js";
import { lab as en_lab } from "./en/lab.js";
import { labFlows as en_labFlows } from "./en/labFlows.js";
import { bankHubLab as en_bankHubLab } from "./en/bankHubLab.js";
import { einvoiceLab as en_einvoiceLab } from "./en/einvoiceLab.js";
import { einvoiceAgency as en_einvoiceAgency } from "./en/einvoiceAgency.js";
import { ai as en_ai } from "./en/ai.js";
import { configSync as en_configSync } from "./en/configSync.js";
import { tingeeConnections as en_tingeeConnections } from "./en/tingeeConnections.js";
import { partnerReport as en_partnerReport } from "./en/partnerReport.js";
import { credentialHistory as en_credentialHistory } from "./en/credentialHistory.js";
import { partnerWallet as en_partnerWallet } from "./en/partnerWallet.js";
import { appLinks as en_appLinks } from "./en/appLinks.js";
import { common as vi_common } from "./vi/common.js";
import { shell as vi_shell } from "./vi/shell.js";
import { auth as vi_auth } from "./vi/auth.js";
import { attention as vi_attention } from "./vi/attention.js";
import { overview as vi_overview } from "./vi/overview.js";
import { integrations as vi_integrations } from "./vi/integrations.js";
import { audience as vi_audience } from "./vi/audience.js";
import { subscriptions as vi_subscriptions } from "./vi/subscriptions.js";
import { revenue as vi_revenue } from "./vi/revenue.js";
import { planMapping as vi_planMapping } from "./vi/planMapping.js";
import { feedback as vi_feedback } from "./vi/feedback.js";
import { support as vi_support } from "./vi/support.js";
import { appHome as vi_appHome } from "./vi/appHome.js";
import { bankTransfer as vi_bankTransfer } from "./vi/bankTransfer.js";
import { sharedHub as vi_sharedHub } from "./vi/sharedHub.js";
import { shopIntegrationCards as vi_shopIntegrationCards } from "./vi/shopIntegrationCards.js";
import { customers as vi_customers } from "./vi/customers.js";
import { acquisitionOps as vi_acquisitionOps } from "./vi/acquisitionOps.js";
import { invoiceQuota as vi_invoiceQuota } from "./vi/invoiceQuota.js";
import { resale as vi_resale } from "./vi/resale.js";
import { sources as vi_sources } from "./vi/sources.js";
import { reliability as vi_reliability } from "./vi/reliability.js";
import { cost as vi_cost } from "./vi/cost.js";
import { mailStatus as vi_mailStatus } from "./vi/mailStatus.js";
import { integrationRoutes as vi_integrationRoutes } from "./vi/integrationRoutes.js";
import { mailProviders as vi_mailProviders } from "./vi/mailProviders.js";
import { dependencies as vi_dependencies } from "./vi/dependencies.js";
import { products as vi_products } from "./vi/products.js";
import { platform as vi_platform } from "./vi/platform.js";
import { staff as vi_staff } from "./vi/staff.js";
import { teams as vi_teams } from "./vi/teams.js";
import { ownership as vi_ownership } from "./vi/ownership.js";
import { components as vi_components } from "./vi/components.js";
import { partnerSets as vi_partnerSets } from "./vi/partnerSets.js";
import { bankPartners as vi_bankPartners } from "./vi/bankPartners.js";
import { partnerLab as vi_partnerLab } from "./vi/partnerLab.js";
import { lab as vi_lab } from "./vi/lab.js";
import { labFlows as vi_labFlows } from "./vi/labFlows.js";
import { bankHubLab as vi_bankHubLab } from "./vi/bankHubLab.js";
import { einvoiceLab as vi_einvoiceLab } from "./vi/einvoiceLab.js";
import { einvoiceAgency as vi_einvoiceAgency } from "./vi/einvoiceAgency.js";
import { ai as vi_ai } from "./vi/ai.js";
import { configSync as vi_configSync } from "./vi/configSync.js";
import { tingeeConnections as vi_tingeeConnections } from "./vi/tingeeConnections.js";
import { partnerReport as vi_partnerReport } from "./vi/partnerReport.js";
import { credentialHistory as vi_credentialHistory } from "./vi/credentialHistory.js";
import { partnerWallet as vi_partnerWallet } from "./vi/partnerWallet.js";
import { appLinks as vi_appLinks } from "./vi/appLinks.js";

export { LOCALES, currentLocale, intlLocaleOf, useLocale, useLocaleStore, type Locale } from "./core.js";

/** Bản gốc — nguồn của KIỂU khoá. Thêm namespace: tạo `vi/<ns>.ts` + `en/<ns>.ts` rồi khai ở cả hai bảng dưới. */
const VI = {
  featureReadiness:vi_featureReadiness,
  integrationControl:vi_integrationControl,
  partnerConnections:vi_partnerConnections,
  partnerReleases:vi_partnerReleases,
  common: vi_common,
  shell: vi_shell,
  auth: vi_auth,
  attention: vi_attention,
  overview: vi_overview,
  integrations: vi_integrations,
  audience: vi_audience,
  subscriptions: vi_subscriptions,
  revenue: vi_revenue,
  planMapping: vi_planMapping,
  feedback: vi_feedback,
  support: vi_support,
  appHome: vi_appHome,
  bankTransfer: vi_bankTransfer,
  sharedHub: vi_sharedHub,
  shopIntegrationCards: vi_shopIntegrationCards,
  customers: vi_customers,
  acquisitionOps: vi_acquisitionOps,
  invoiceQuota: vi_invoiceQuota,
  resale: vi_resale,
  sources: vi_sources,
  reliability: vi_reliability,
  cost: vi_cost,
  mailStatus: vi_mailStatus,
  mailProviders: vi_mailProviders,
  integrationRoutes: vi_integrationRoutes,
  dependencies: vi_dependencies,
  products: vi_products,
  platform: vi_platform,
  staff: vi_staff,
  teams: vi_teams,
  ownership: vi_ownership,
  components: vi_components,
  partnerSets: vi_partnerSets,
  bankPartners: vi_bankPartners,
  partnerLab: vi_partnerLab,
  lab: vi_lab,
  labFlows: vi_labFlows,
  bankHubLab: vi_bankHubLab,
  einvoiceLab: vi_einvoiceLab,
  einvoiceAgency: vi_einvoiceAgency,
  ai: vi_ai,
  configSync: vi_configSync,
  tingeeConnections: vi_tingeeConnections,
  partnerReport: vi_partnerReport,
  credentialHistory: vi_credentialHistory,
  partnerWallet: vi_partnerWallet,
  appLinks: vi_appLinks,
} as const;

const EN = {
  featureReadiness:en_featureReadiness,
  integrationControl:en_integrationControl,
  partnerConnections:en_partnerConnections,
  partnerReleases:en_partnerReleases,
  common: en_common,
  shell: en_shell,
  auth: en_auth,
  attention: en_attention,
  overview: en_overview,
  integrations: en_integrations,
  audience: en_audience,
  subscriptions: en_subscriptions,
  revenue: en_revenue,
  planMapping: en_planMapping,
  feedback: en_feedback,
  support: en_support,
  appHome: en_appHome,
  bankTransfer: en_bankTransfer,
  sharedHub: en_sharedHub,
  shopIntegrationCards: en_shopIntegrationCards,
  customers: en_customers,
  acquisitionOps: en_acquisitionOps,
  invoiceQuota: en_invoiceQuota,
  resale: en_resale,
  sources: en_sources,
  reliability: en_reliability,
  cost: en_cost,
  mailStatus: en_mailStatus,
  mailProviders: en_mailProviders,
  integrationRoutes: en_integrationRoutes,
  dependencies: en_dependencies,
  products: en_products,
  platform: en_platform,
  staff: en_staff,
  teams: en_teams,
  ownership: en_ownership,
  components: en_components,
  partnerSets: en_partnerSets,
  bankPartners: en_bankPartners,
  partnerLab: en_partnerLab,
  lab: en_lab,
  labFlows: en_labFlows,
  bankHubLab: en_bankHubLab,
  einvoiceLab: en_einvoiceLab,
  einvoiceAgency: en_einvoiceAgency,
  ai: en_ai,
  configSync: en_configSync,
  tingeeConnections: en_tingeeConnections,
  partnerReport: en_partnerReport,
  credentialHistory: en_credentialHistory,
  partnerWallet: en_partnerWallet,
  appLinks: en_appLinks,
} as const satisfies { [N in keyof typeof VI]: { [K in keyof (typeof VI)[N]]: string } };

/** Cả hai bản — cho test bất biến (`__tests__/i18n.test.ts`). Giao diện dùng `useT` / `translate`. */
export const DICTIONARIES = { vi: VI, en: EN } as const;

export type Namespace = keyof typeof VI;
export type MessageKey<N extends Namespace> = keyof (typeof VI)[N] & string;
type Vars = Readonly<Record<string, string | number>>;

const MESSAGES: Record<Locale, { [N in Namespace]: { readonly [K in MessageKey<N>]: string } }> = { vi: VI, en: EN };

/** Dịch ngoài React (formatter, thông báo dựng sẵn). Trong component dùng `useT` để đổi ngôn ngữ là render lại. */
export function translate<N extends Namespace>(ns: N, key: MessageKey<N>, vars?: Vars, locale: Locale = currentLocale()): string {
  const dict = MESSAGES[locale][ns] as Record<string, string>;
  return interpolate(dict[key] ?? (VI[ns] as Record<string, string>)[key] ?? key, vars);
}

/** `const t = useT("integrations"); t("title")` — khoá sai là lỗi `tsc`. */
export function useT<N extends Namespace>(ns: N): (key: MessageKey<N>, vars?: Vars) => string {
  const locale = useLocale();
  return useCallback((key: MessageKey<N>, vars?: Vars) => translate(ns, key, vars, locale), [ns, locale]);
}
